/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useGetNotesFileSystemInvalidator } from './use-get-notes-file-system';

/**
 * `Payload` type.
 */

type Payload = {
  name: string;
  type: 'folder' | 'file';
  parent_id?: string | null;
};

/**
 * Post new folder.
 */

async function postNewFolder(
  client: AxiosInstance,
  name: string,
  type: string,
  parent_id?: string | null
): Promise<void> {
  return await client({
    method: 'post',
    data: {
      name,
      parent_id: parent_id ?? null,
      type
    },
    url: resolveAppUrl('appsNotes')
  });
}

/**
 * Export `usePostNotesNewItem`.
 */

export function usePostNotesNewItem() {
  const client = useRequestProvider();
  const invalidator = useGetNotesFileSystemInvalidator();

  return useMutation({
    mutationFn: async ({ name, parent_id, type }: Payload) => {
      const result = await postNewFolder(client, name, type, parent_id);

      await invalidator();

      return result;
    }
  });
}
